import { Component, OnInit, ElementRef } from '@angular/core';
import { RicambiService } from '../service/ricambi.service';
import { Macchina } from '../models/macchina';
import { Accessorio } from '../models/accessorio';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/switchMap';

import { Ricambio } from '../models/ricambio';
import { Carrello } from '../models/carrello';
import { MatSnackBar } from '@angular/material';
import {UserService} from '../service/user.service';
 
@Component({
    selector: 'app-tws-accessorio',
    templateUrl: './tws-accessorio.component.html',
    styleUrls: ['./tws-accessorio.component.css']
})
export class TwsAccessorioComponent implements OnInit {
    public accessorioSelezionato: Accessorio;
    constructor(private ricambiService: RicambiService,
        private route: ActivatedRoute,
        private userService: UserService,
        private location: Location,
        private elementRef: ElementRef,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.route.params.switchMap((params: Params) => this.ricambiService.getAccessorio(+params['id']))
            .subscribe(accessorio => this.caricato(accessorio));
    }
    caricato(m: Accessorio): void {
        this.accessorioSelezionato = m;

    }
    aggiungiCarrello(ricambio: Accessorio): void {
         let qta=1;
        if(ricambio.qta && ricambio.qta>1){
            qta=ricambio.qta;
        }
        this.ricambiService.aggiungiCarrello(ricambio.id, qta).then(carrello => this.aggiunto(carrello));

    }

    aggiunto(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Prodotto aggiunto al carrello"), "", { duration: 2000 });
    }
    get utente():any{
        return this.userService.getProfilo();
    }
}



// WEBPACK FOOTER //
// ./src/app/tws-accessorio/tws-accessorio.component.ts